// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Hierarchy3Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Hierarchy3/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.167 6.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM15.833 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM4.167 18.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.167 13.958a.63.63 0 0 1-.625-.625V6.667a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625c0 1.825.883 2.708 2.708 2.708h5.833a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625H7.5c-1.133 0-2.042-.292-2.708-.842v3.55a.63.63 0 0 1-.625.625Z"
}));
export default Hierarchy3Icon;